import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { createComponent, FelaComponent } from 'react-fela'
import baseTheme from 'design-framework/utils/base-ui-theme'
import { bmsTheme, __title, __wrapper, __select } from './__style'

const Title = createComponent(__title)
const DropDownWrapper = createComponent(__wrapper)

const styles = theme => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		color: baseTheme.primary(baseTheme).backgroundColor,
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
})

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const getMenuProps = ({ width, minWidth, isDenseMargin, showMenuAtBottom }) => {
	let menuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: width || minWidth || 250,
			},
		},
	}

	if (showMenuAtBottom) {
		menuProps = {
			...menuProps,
			anchorOrigin: {
				vertical: 'bottom',
				horizontal: 'center',
			},
			transformOrigin: {
				vertical: 'top',
				horizontal: 'center',
			},
			getContentAnchorEl: null,
		}
	}

	if (isDenseMargin) {
		menuProps = {
			...menuProps,
			MenuListProps: {
				dense: true,
			},
		}
	}

	return menuProps
}

const SelectComponent = ({
	margin,
	width,
	minWidth,
	renderValue,
	showMenuAtBottom,
	variant,
	...props
}) => {
	const isOutlined = variant === 'outlined'
	const menuProps = getMenuProps({
		minWidth,
		width,
		isDenseMargin: margin === 'dense',
		showMenuAtBottom,
	})
	const updatedProps = { ...props }
	if (renderValue) {
		updatedProps.renderValue = renderValue
	}
	if (isOutlined) {
		return (
			<FelaComponent style={__select()}>
				{({ className }) => (
					<Select
						classes={{ select: className }}
						MenuProps={menuProps}
						variant={variant}
						{...updatedProps}
					/>
				)}
			</FelaComponent>
		)
	}

	return <Select MenuProps={menuProps} variant={variant} {...updatedProps} />
}

class DropDownMaterial extends React.Component {
	constructor(props) {
		super()
		this.state = {
			value: props.initalValue !== undefined ? props.initalValue : '',
		}
	}

	static getDerivedStateFromProps(props, state) {
		if (props.value !== undefined && props.value !== state.value) {
			return { value: props.value }
		}

		return null
	}

	handleChange = event => {
		// this.setState({ [event.target.name]: event.target.value })
		this.setState({
			value: event.target.value,
		})
		this.props.handleChange(event.target.value)
	}

	render() {
		const {
			title,
			payload,
			disabled,
			variant,
			width,
			minWidth,
			margin,
			unsetWrapperPadding,
			showMenuAtBottom,
			renderValue,
			IconComponent,
			themeToUse = baseTheme,
		} = this.props
		const { value } = this.state

		return (
			<MuiThemeProvider theme={bmsTheme(themeToUse)}>
				<DropDownWrapper
					disabled={disabled}
					width={width}
					minWidth={minWidth}
					unsetWrapperPadding={unsetWrapperPadding}
				>
					{title && <Title>{title}</Title>}
					<SelectComponent
						value={value}
						onChange={this.handleChange}
						variant={variant}
						fullWidth
						margin={margin}
						width={width}
						minWidth={minWidth}
						showMenuAtBottom={showMenuAtBottom}
						renderValue={renderValue}
						disabled={disabled}
						{...(IconComponent ? { IconComponent } : {})}
					>
						{payload.map(({ key, value: Value }) => (
							<MenuItem key={key} value={key}>
								{Value}
							</MenuItem>
						))}
					</SelectComponent>
				</DropDownWrapper>
			</MuiThemeProvider>
		)
	}
}

DropDownMaterial.propTypes = {
	/** Title of type string */
	title: PropTypes.string,
	/** Payload of type Array */
	payload: PropTypes.array.isRequired,
	/** onChange event */
	handleChange: PropTypes.func.isRequired,
	/** Inital value */
	initalValue: PropTypes.string,
	disabled: PropTypes.bool,
	IconComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
	/** Variant of the select component - standard / outlined / filled */
	variant: PropTypes.string,
	/** Width of the Dropdown and the menu */
	width: PropTypes.string,
	/** minWidth of the Dropdown and the menu */
	minWidth: PropTypes.string,
	/** Do we want dense margin - value is 'dense' */
	margin: PropTypes.string,
	/** Remove padding from the Dropdown Wrapper */
	unsetWrapperPadding: PropTypes.bool,
	/** Set menu position to bottom-center */
	showMenuAtBottom: PropTypes.bool,
	/** custom function to show different data that the actual value in the menu */
	renderValue: PropTypes.func,
}

DropDownMaterial.defaultProps = {
	title: '',
	initalValue: '',
	disabled: false,
	variant: 'standard',
	unsetWrapperPadding: false,
	showMenuAtBottom: false,
}

export default withStyles(styles)(DropDownMaterial)
